import EditIcon from "@mui/icons-material/Edit";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import IconButton from "@mui/material/IconButton";
import {Avatar, Stack, Tooltip} from "@mui/material";
import {deepOrange, deepPurple, grey, lightGreen} from "@mui/material/colors";
import {GRID_DETAIL_PANEL_TOGGLE_FIELD} from "@mui/x-data-grid-pro";
import * as React from "react";
import PivotTableChartIcon from '@mui/icons-material/PivotTableChart';
import Badge from "@mui/material/Badge";
import Box from "@mui/material/Box";

export const WorkQueueCdpGridColumns = ({ hideActions, handleFilter, cdpFilter, workQueueCDP, handleExpression, handleEdit, selectedCDP,
                                            CDPcontext, expandCdpId, openSourceWindow, handleExploreExternalData, handleExploreCDPV, handlePivot}) => [
    {
        field: "cDPExplore",
        renderHeader: () => {
            if (cdpFilter === 'black') {
                return (
                    <EditIcon fontSize="small" style={{cursor: 'pointer'}} onClick={() => handleFilter()}/>
                );
            }
            if (cdpFilter === 'blue') {
                return (
                    <EditIcon fontSize="small" style={{cursor: 'pointer'}} color="primary" onClick={() => handleFilter()}/>
                );
            }
            if (cdpFilter === 'red') {
                return (
                    <EditIcon fontSize="small" style={{cursor: 'pointer'}} color="error" onClick={() => handleFilter()}/>
                );
            }
            if (cdpFilter === 'all') {
                return (
                    <AllInclusiveIcon fontSize="small" style={{cursor: 'pointer'}}  onClick={() => handleFilter()}/>
                );
            }
        },
        headerName: '',
        disableColumnMenu: true,
        width: 20,
        padding: 0,
        margin: 0,
        sortable: false,
        menu: false,
        filterable: false,
        renderCell: (workQueueCDP) => {
            if((workQueueCDP.row.mockOrigin=== 'Input') && workQueueCDP.row.mockValue === null ){
                return (
                    <IconButton
                        size="small"
                        variant="contained"
                        onClick = {(e) => {
                            if  (e.key === 'Enter')
                            {
                                console.log('Enter key pressed');
                                handleEdit(workQueueCDP.row);
                                // handleEdit(workQueueCDP.row)
                            }

                            // handleEdit(workQueueCDP.row)

                        }}
                    >
                        <CDPcontext.Provider value={selectedCDP}>
                            <EditIcon fontSize="small" color="error"
                                // onKeyPress={(e) => e.key === 'Enter' && handleEdit(workQueueCDP.row)}
                                // onCellKeyDown ={(e) => e.key === 'Enter' && handleEdit(workQueueCDP.row)}
                                      onKeyPress= {(e) => {
                                          if  (e.key === 'Enter') {
                                              console.log('Enter key pressed');

                                              // handleEdit(workQueueCDP.row)
                                          }
                                      }}


                                // onKeyPress={(event) => {
                                //     if (event.ctrlKey && event.key== 'Enter')
                                //         this.handleEdit(workQueueCDP.row);
                                // }}
                                      onClick= {() => handleEdit(workQueueCDP.row)}
                            />
                        </CDPcontext.Provider>
                    </IconButton>
                );}
            if((workQueueCDP.row.mockOrigin=== 'Assumption') && workQueueCDP.row.mockValue === null ){
                return (
                    <IconButton
                        size="small"
                        variant="contained"

                    >
                        <CDPcontext.Provider value={selectedCDP}>
                            <EditIcon fontSize="small" color="primary" onClick= {() => handleEdit(workQueueCDP.row)}/>
                        </CDPcontext.Provider>
                    </IconButton>
                );}
            if((workQueueCDP.row.mockOrigin=== 'Input' || workQueueCDP.row.mockOrigin===  'Assumption') && workQueueCDP.row.mockValue !== null ){
                return (
                    <IconButton
                        size="small"
                        variant="contained"

                    >
                        <CDPcontext.Provider value={selectedCDP}>
                            <EditIcon fontSize="small" color="primary" onClick= {() => handleEdit(workQueueCDP.row)}/>
                        </CDPcontext.Provider>
                    </IconButton>
                );}
        }
    },
    {
        field: 'id',
        headerName: 'ID',
        description: '',
        sortable: true,
        renderCell: (workQueueCDP) =>{              return <div className="rowId"
                                                                onClick= {() => handleExpression(workQueueCDP.row.id,  workQueueCDP.row.contractSectionId, fetchWorkQueueCDP)}
                                                                style={{cursor:'pointer'}}
        >{workQueueCDP.row.id}</div>;},
        // editable: true,
        width: 60,
        hide: true,
    },
    // {
    //     field: 'contractSectionId',
    //     headerName: 'cs',
    //     description: '',
    //     sortable: true,
    //     // editable: true,
    //     width: 30,
    //     hide: true,
    // },
    {
        field: 'contractSectionId',
        headerName: 'cs',
        // renderCell: (workQueueCDP) => {
        //     return <div className="rowitem">{workQueueCDP.row.contractSectionId}</div>;},
        description: '',
        sortable: true,
        // editable: true,
        width: 30,
        hide: true,
    },
    {
        field: 'ordinalNumber',
        headerName: '#',
        description: '',
        sortable: false,
        // editable: true,
        width: 30,
        hide: true,
    },
    // {
    //     field: 'dataPointId',
    //     headerName: 'Data Point',
    //     description: '',
    //     sortable: false,
    //     width: 90,
    // },
    {
        field: 'dataPointName',
        headerName: 'Name',
        //https://stackoverflow.com/questions/65592494/material-ui-datagrid-with-nested-data ANSWER 6 on page
        renderCell: (workQueueCDP) => {
            return (
                <Tooltip  enterDelay={1000}  title={<span style={{whiteSpace: 'pre-line'}}>
                    {"cdp id: " + workQueueCDP.row.id +
                        "\ncdpv id: " + workQueueCDP.row.cdpvId +
                        "\ndata point id: " + workQueueCDP.row.dataPointId +
                        "\ndata point name: " + workQueueCDP.row.dataPointName +
                        "\nsource section id: " + workQueueCDP.row.sourceContractSectionId +
                        "\nsource contract data point id: " + workQueueCDP.row.sourceContractDataPointId +
                        "\nfolder: " + workQueueCDP.row.folderName +
                        "\nversion: " + workQueueCDP.row.versionNumber +
                        "\nstatus: " + workQueueCDP.row.status +
                        "\ncycle: " + workQueueCDP.row.cycleInd +
                        "\ncalc group: " + workQueueCDP.row.calcGroup +
                        "\ncalc wave: " + workQueueCDP.row.calcWave
                    }</span>}>

                    <div className="rowitem"
                         onClick= {() => handleExpression(workQueueCDP.row.id,  workQueueCDP.row.contractSectionId, fetchWorkQueueCDP)}
                         style={{cursor:'pointer',
                             backgroundColor: workQueueCDP.row.id === expandCdpId ? 'yellow' : 'transparent',
                         }}
                    >{workQueueCDP.row.dataPointName}</div></Tooltip>)},
        description: '',
        sortable: true,
        width: 290,
    },
    {
        field: 'mockValue',
        headerName: 'Value',
        description: '',
        sortable: true,
        width: 300,
        editable: false,
        renderCell: (workQueueCDP) =>
        {
            if(workQueueCDP.row.cdpvCount > 1  && workQueueCDP.row.pivotAttributeCount === 0){
                // return (
                //     <Tooltip  enterDelay={1000} title={"Multiple values.  Click to see all."}>
                //         <Avatar
                //             onClick= {() => handleExploreCDPV(workQueueCDP.row.id,  workQueueCDP.row)}
                //             sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>m</Avatar>
                //     </Tooltip>)
                return (

                    <Tooltip  enterDelay={1000} title={"Multiple values.  Click to see all."}>
                        <Avatar
                            // onClick= {() => handleExploreCDPV(workQueueCDP.row.id,  workQueueCDP.row)}
                            onClick= {() => handleExploreCDPV(workQueueCDP.row)}
                            sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>m</Avatar>
                    </Tooltip>
                        )
            }
            if(workQueueCDP.row.cdpvCount > 1 && workQueueCDP.row.pivotAttributeCount > 0){
                // return (
                //     <Tooltip  enterDelay={1000} title={"Multiple values.  Click to see all."}>
                //         <Avatar
                //             onClick= {() => handleExploreCDPV(workQueueCDP.row.id,  workQueueCDP.row)}
                //             sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>m</Avatar>
                //     </Tooltip>)
                return (
                    <Stack direction="row" spacing={3}>
                        <Tooltip  enterDelay={1000} title={"Multiple values.  Click to see all."}>
                            <Avatar
                                onClick= {() => handleExploreCDPV(workQueueCDP.row)}
                                sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>m</Avatar>
                        </Tooltip>

                        <Tooltip  enterDelay={1000} title={"Multiple values.  Click to pivot rows."}>
                            {/*<Tooltip  enterDelay={1000} title={"Pivot Attributes: " + workQueueCDP.row.pivotAttributeCount}>*/}
                            <PivotTableChartIcon
                                onClick= {() => handlePivot( workQueueCDP.row)}
                                sx={{ color: "#2e7d32"}}
                            />
                        </Tooltip>
                    </Stack>
                )
            }
            if(workQueueCDP.row.cdpvCount === 1 && (workQueueCDP.row.mockValue !== '')  && (workQueueCDP.row.mockValue !== null)){
                return (
                    <Tooltip title={"Single Value."}>
                        <div style={{color: workQueueCDP.row.mockValue === 'Fail' && workQueueCDP.row.folderName === 'Health Checks' ? 'red' : 'inherit'}}>
                            {workQueueCDP.row.mockValue}
                        </div>
                    </Tooltip>)
            }
            if (workQueueCDP.row.cdpvCount === 1 && (workQueueCDP.row.mockValue === '')  && (workQueueCDP.row.mockValue === null)  && (workQueueCDP.row.expression !== '')  && (workQueueCDP.row.expression !== null)  ){
                return (
                    <Tooltip title={"Matching succeeded but no value returned."}>
                        <p style = {{fontStyle: "italic"}}>no value returned</p>
                    </Tooltip>)}
            if((workQueueCDP.row.cdpvCount === 0) && (workQueueCDP.row.sourceCdpvCount === 0)){
                return (
                    <Tooltip title={"The source record had no value(s) when it was looked up."}>
                        <p style = {{fontStyle: "italic"}}>source missing value record(s)</p>
                        {/*sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>{filteredCDP.row.mockIndicator} </Avatar>*/}
                    </Tooltip>)}
            if((workQueueCDP.row.cdpvCount === 0) && (workQueueCDP.row.sourceCdpvCount !== 0) && (workQueueCDP.row.sourceCdpvfCount !== 0)){
                return (
                    <Tooltip title={"The filters on the source values failed to find a match."}>
                        <p style = {{fontStyle: "italic", color: "red"}}>value matching failed</p>
                        {/*sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>{filteredCDP.row.mockIndicator} </Avatar>*/}
                    </Tooltip>)}
            if((workQueueCDP.row.cdpvCount === 1) && ((workQueueCDP.row.mockValue === '')  || (workQueueCDP.row.expression === null)) && (workQueueCDP.row.expression !== '')  && (workQueueCDP.row.expression !== null)){
                return (
                    <Tooltip title={"The calculation of the expression either failed or did not run."}>
                        <p style = {{fontStyle: "italic"}}>expression failed</p>
                        {/*sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>{filteredCDP.row.mockIndicator} </Avatar>*/}
                    </Tooltip>)}
// {
//                     return <div
//                     >{workQueueCDP.row.mockValue}</div>;},
        },
    },
    {
        field: 'dataPoint.dataType',
        headerName: 'Name',
        //https://stackoverflow.com/questions/65592494/material-ui-datagrid-with-nested-data ANSWER 6 on page
        renderCell: (workQueueCDP) => {
            return <div className="rowitem"

            >{workQueueCDP.row.dataType}</div>;},
        description: '',
        hide: true,
        sortable: false,
        width: 280,
    },
    {
        // field: 'mockIndicator',
        field: GRID_DETAIL_PANEL_TOGGLE_FIELD,
        type: 'actions',  // Required for built-in expand behavior
        headerName: 'Exp',
        renderCell: (workQueueCDP) =>
        {
            if((workQueueCDP.row.mockExpression !== null) && (workQueueCDP.row.mockExpression !== '')){
                return (
                    <Tooltip title={"Value comes from an expression.  Click to see."}>
                        <Avatar sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepOrange[500], cursor: 'pointer', }}>e</Avatar>
                    </Tooltip>)}
            // if(workQueueCDP.row.mockIndicator=='m'){
            //     return (
            //         <Avatar sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>{workQueueCDP.row.mockIndicator} </Avatar>)}
        },
        description: '',
        sortable: false,
        width: 50,
    },
    {
        field: 'sourceContractDataPointId',
        headerName: 'Source',
        description: '',
        width: 60,
        renderCell: ({ row }) => {
            if (!row.sourceSection) return <div />;

            // Gather all parent sections dynamically
            const parentSections = [];
            for (let i = 10; i >= 1; i--) {
                const section = row[`sourceParentSection${i}`];
                if (section) parentSections.push(section);
            }

            const tooltipContent = `from:\n${row.contractName}\n\nin:\n${parentSections.join('\n')}\n${row.sourceSection}`;

            return (
                <Tooltip placement="right-end" title={<span style={{ whiteSpace: 'pre-line' }}>{tooltipContent}</span>}>
                    <Avatar
                        sx={{ height: 20, width: 20, fontSize: 16, bgcolor: grey[500], cursor: 'pointer', }}
                        onClick={() => openSourceWindow(row)}
                    >
                        s
                    </Avatar>
                </Tooltip>
            );
        }

    },
    {
        field: 'externalData',
        headerName: 'External Data',
        description: '',
        sortable: false,
        width: 100,
        renderCell: (workQueueCDP) => {
            if (workQueueCDP.row.externalDataCount > 0) {
                return (
                    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                        <Tooltip
                            enterDelay={1000}
                            title={"Data comes from external source. Click to see details."}
                        >
                            <Avatar
                                onClick={() => handleExploreExternalData(workQueueCDP.row)}
                                sx={{
                                    height: 20,
                                    width: 20,
                                    fontSize: 16,
                                    bgcolor: lightGreen[500],
                                    cursor: 'pointer'
                                }}
                            >
                                d
                            </Avatar>
                        </Tooltip>

                        {workQueueCDP.row.adjustedInd === true && (
                            <Tooltip
                                enterDelay={1000}
                                title={"Adjustment(s)"}
                            >
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: -3,
                                        right: -8,
                                        height: 12,
                                        width: 12,
                                        minWidth: 12,
                                        borderRadius: '50%',
                                        backgroundColor: 'black',
                                        color: 'white',
                                        fontSize: 12,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        lineHeight: 1,
                                        cursor: 'pointer'
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    a
                                </Box>
                            </Tooltip>
                        )}
                    </Box>
                );
            }
            return null;
        },
    },
    // {
    //     field: 'externalData',
    //     headerName: 'External Data',
    //     description: '',
    //     sortable: false,
    //     width: 100,
    //     renderCell: (workQueueCDP) => {
    //         if (workQueueCDP.row.externalDataCount > 0) {
    //             return (
    //
    //                 <Tooltip
    //                     enterDelay={1000}
    //                     title={"Data comes from external source. Click to see details."}
    //                 >
    //                     <Badge
    //                         badgeContent="a"
    //                         invisible={workQueueCDP.row.adjustedInd !== true}
    //                         anchorOrigin={{
    //                             vertical: "top",
    //                             horizontal: "right"
    //                         }}
    //                         slotProps={{
    //                             badge: {
    //                                 title: "Adjustment(s)"  // 👈 tooltip for badge
    //                             }
    //                         }}
    //                         sx={{
    //                             "& .MuiBadge-badge": {
    //                                 backgroundColor: "black",
    //                                 color: "white",
    //                                 fontSize: 12,
    //
    //                                 height: 12,
    //                                 width: 12,
    //                                 minWidth: 12,
    //                                 borderRadius: "50%",
    //
    //                                 padding: 0,
    //                                 display: "flex",
    //                                 alignItems: "center",
    //                                 justifyContent: "center",
    //
    //                                 cursor: 'pointer',
    //
    //                                 transform: "translate(75%, -50%)"
    //                             }
    //                         }}
    //                     >
    //                         <Avatar
    //                             onClick={() => handleExploreExternalData(workQueueCDP.row)}
    //                             sx={{
    //                                 height: 20,
    //                                 width: 20,
    //                                 fontSize: 16,
    //                                 bgcolor: lightGreen[500],
    //                                 cursor: 'pointer',
    //                             }}
    //                         >
    //                             d
    //                         </Avatar>
    //                     </Badge>
    //                 </Tooltip>
    //                 // <Tooltip
    //                 //     enterDelay={1000}
    //                 //     title={"Data comes from external source. Click to see details."}
    //                 // >
    //                 //              <Badge
    //                 //             badgeContent="a"
    //                 //             invisible={workQueueCDP.row.adjustedInd !== true}
    //                 //             anchorOrigin={{
    //                 //                 vertical: "top",
    //                 //                 horizontal: "right"
    //                 //             }}
    //                 //             sx={{
    //                 //                 "& .MuiBadge-badge": {
    //                 //                     backgroundColor: "black",
    //                 //                     color: "white",
    //                 //                     fontSize: 12,
    //                 //
    //                 //                     height: 12,
    //                 //                     width: 12,
    //                 //                     minWidth: 12,
    //                 //                     borderRadius: "50%",
    //                 //
    //                 //                     padding: 0,
    //                 //                     display: "flex",
    //                 //                     alignItems: "center",
    //                 //                     justifyContent: "center",
    //                 //
    //                 //                     transform: "translate(75%, -50%)" // tweak as needed
    //                 //                 }
    //                 //             }}
    //                 //         >
    //                 //         <Avatar
    //                 //             onClick={() => handleExploreExternalData(workQueueCDP.row)}
    //                 //             sx={{
    //                 //                 height: 20,
    //                 //                 width: 20,
    //                 //                 fontSize: 16,
    //                 //                 bgcolor: lightGreen[500]
    //                 //             }}
    //                 //         >
    //                 //             d
    //                 //         </Avatar>
    //                 //     </Badge>
    //                 // </Tooltip>
    //             );
    //         }
    //         return null;
    //     },
    // },
    // {
    //     field: 'externalData',
    //     headerName: 'External Data',
    //     description: '',
    //     sortable: false,
    //     width: 100,
    //     renderCell: (workQueueCDP) =>
    //     {
    //         if(workQueueCDP.row.externalDataCount > 0) {
    //             // if(filteredCDP.row.mockIndicator==='f'){
    //             return (
    //                 <Tooltip   enterDelay={1000}  title={"Data comes from external source.  Click to see details."}>
    //                     {/*<AccountTreeIcon*/}
    //                     {/*    onClick= {() => handleExploreExternalData( contracts.row)}*/}
    //                     {/*/>)}*/}
    //                     <Avatar
    //                         onClick= {() => handleExploreExternalData( workQueueCDP.row)}
    //                         sx={{ height:20, width: 20, fontSize: 16, bgcolor: lightGreen[500] }}>d</Avatar>
    //                     {workQueueCDP.row.adjustedInd === true &&
    //                         <Badge color="secondary" badgeContent="adjusted" />}
    //                     {/*sx={{ height:20, width: 20, fontSize: 16, bgcolor: teal[500] }}>{filteredCDP.row.mockIndicator} </Avatar>*/}
    //                 </Tooltip>)}
    //     },
    // },
    {
        field: 'mockOrigin',
        headerName: 'Origin',
        description: '',
        sortable: false,
        width: 100,
    },
    {
        field: 'externalDataCount',
        headerName: 'External',
        description: '',
        sortable: false,
        width: 100,
        hide: true,
    },
    {
        field: 'mockRawExpression',
        headerName: 'Raw Expression',
        description: '',
        sortable: false,
        width: 100,
        hide: true,
    },
    {
        field: 'contractLevel',
        headerName: 'Level',
        description: '',
        sortable: false,
        defaultValue: 'All',
        width: 150,
        hide: true,
    },
    {
        field: 'mockRawExpression',
        headerName: 'raw expression',
        description: '',
        sortable: false,
        width: 150,
        hide: true,
    },
    {
        field: 'sourceParentSectionId1',
        headerName: 'Parent 1',
        description: '',
        sortable: false,
        width: 150,
        hide: true,
    },
    {
        field: 'sourceParentSectionId2',
        headerName: 'Parent 2',
        description: '',
        sortable: false,
        width: 150,
        hide: true,
    },
    {
        field: 'value',
        headerName: 'Value',
        description: '',
        sortable: false,
        width: 150,
        hide: true,
    },
]
